import { ReactElement } from "react";
import H1 from "./H1";

export default function Footer() {
  return (
    <footer>
      <section className="grid grid-cols-3 gap-6">
        <section className="border-t-2">
          <H1>Services</H1>
          <ul>
            <li>Interface Design</li>
            <li>Experience Design</li>
            <li>Data Visualisation</li>
            <li>Information Architecture</li>
            <li>User Research</li>
            <li>Product Strategy</li>
            <li>Interaction Design</li>
          </ul>
        </section>
        <section className="border-t-2">
          <H1>Toolkit</H1>
          <ul>
            <li>Figma</li>
            <li>Tableau</li>
            <li>Adobe Creative Suite</li>
            <li>Blender</li>
          </ul>
        </section>
        <section className="border-t-2">
          <H1>Bio</H1>
          {[
            "Designing for people, not just pixels. I’ve completed my Masters in UX Design from MIT Avantika University, where I explored how stories, systems and empathy shape better digital worlds.",
            "I’ve worked with a startup to design NonVegMart, a food delivery platform and led my capstone project to improve communication between customers and in-house departments within a real estate company. I’ve also developed a range of projects during my coursework  from information design or data visualisations and service design for local salons.",
            "Outside of design! I love photography, playing football and sketching whenever I get the chance. I’m also curious about how AI tools can make the design process easier and more efficient. I’ve completed UI/UX certifications from Edit Silica and secured 2nd position in the Diocese Youth Art Competition.",
          ].map((text, idx) => (
            <p className="mb-4" key={idx}>
              {text}
            </p>
          ))}
        </section>
      </section>
      <section className="mt-22">
        <ul className="flex justify-between">
          <li>
            <a href="https://www.behance.net/noeljohn2">Behance</a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/noel-john-design/">LinkedIn</a>
          </li>
          <li>
            <a href="https://drive.google.com/file/d/1RqiYbDaEoQDVgkvoszVobAovb2a5573-/view">
              Resume
            </a>
          </li>
          <li>
            Currently available to work from India
          </li>
          <li>
            © 2026
          </li>
        </ul>
      </section>
    </footer>
  );
}
